export default __webpack_public_path__ + "static/media/Group -8@2x.252ee408.png";